<template>
  <div class="news">
    <div class="contain">
      <h2>有偿资讯</h2>
      <div class="list">
        <div class="group" v-for="(item,index) in list">
          <h3>{{item.title}}</h3>
          <p>{{item.content}}</p>
          <span @click="hint">付费后方可查看，此条10元</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      list:[
        {title:"1.你只能吃的汉堡和薯条",content:"儿时对食物的感觉会跟随你一生，你儿时的味道是什么？"},
        {title:"2.JSS上海7月新餐厅",content:"JSS上海7月新餐厅 "},
        {title:"3.【生活】北京的酒吧和餐馆的营业时间。",content:"当前北京酒吧和餐厅的营业时间"},
        {title:"4.【新】爱是生命的火花 ",content:"这个夏天，只有爱和花不能被辜负 "},
        {title:"5.叶奈花的作品在JSS上上市了 ",content:"来吧！让我们用JSS试试吧！。"},
        {title:"6.大家好，我是海淀区的JSS！。",content:"开始用JSS订购外卖"},
        {title:"7.好莱坞明星通常吃什么？答案是肥肉... ",content:"好莱坞明星最喜欢的FATBURGER有了JSS！。"},
        {title:"8.北京12家最佳餐厅外卖排行榜",content:"如果您有任何需要，请通过微信联系我们：JssVipService "},
        {title:"9.JSS上的CBD花 ",content:"公司成立于1998年3月，最初的发展主要是以花卉零售为主。"},
        {title:"10.#5月推荐餐厅# ",content:"这里有一些我们推荐的美味餐厅，别犹豫了，去尝尝吧 "},
      ]
    }
  },
  methods:{
    hint(){
      alert('付费后方可查看，此条10元')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.news{
  padding: 20px;
}
h2{
  border-bottom: 1px solid #333333;
  height: 50px;
}
.group{
  background-color: rgb(255, 255, 255);
  cursor: pointer;
  border-bottom: 1px solid #f2f2f2;
  padding: 18px 16px;
  width: 100%;
}
.group p{
  margin: 10px 0;
}
.group span{
  border: 1px solid #4e6ef2;
  border-radius: 5px;
  color: #4e6ef2;
  display: block;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 220px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue